<script>
    import {sgettext} from '../../i18n.js';
    export let data;

</script>

{#if data && data.length}
  {data.length} {(data.length === 1 ? sgettext('$$INSTANCE$$') : sgettext('$$INSTANCES$$'))}
{/if}
